exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".no-package{cursor:pointer}.no-result{margin-top:20px}.remove-package{padding:0 5px;position:absolute;right:-10px;color:#fff;background:#000;top:-10px;border-radius:50%;height:20px;font-size:14px;width:20px;text-align:center;cursor:pointer;line-height:19px}.xnull{border:1px solid #eee;padding:10px;border-radius:4px}.remove-package-tooltip{background:#000;color:#fff;max-width:140px;font-size:13px;text-align:center;padding:5px 10px;border-radius:4px;position:absolute;right:-10px;top:12px;display:none}.remove-package:hover+.remove-package-tooltip{display:initial}.compare-seller-name{max-width:170px;word-wrap:break-word;float:left}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-64238505","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/compare-packages.vue
// module id = EF15
// module chunks = 1